<div class="reports-container">
  <h2>Bug & Notice Reports</h2>

  <!-- Messages -->
  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
    <button class="close-btn" (click)="error = null">&times;</button>
  </div>
  <div *ngIf="successMessage" class="alert alert-success">
    {{ successMessage }}
    <button class="close-btn" (click)="successMessage = null">&times;</button>
  </div>

  <!-- Report Submission Form -->
  <div class="form-section">
    <h3>Submit New Report</h3>
    <form (ngSubmit)="submitReport()">
      <div class="form-row">
        <div class="form-group type-autocomplete">
          <label for="typeName">Type *</label>
          <input
            type="text"
            id="typeName"
            [(ngModel)]="reportForm.typeName"
            name="typeName"
            (input)="onTypeInput()"
            (focus)="onTypeInput()"
            (blur)="hideTypeDropdown()"
            placeholder="Select or enter type..."
            autocomplete="off"
            required
          />
          <div class="dropdown" *ngIf="showTypeDropdown && filteredTypes.length > 0">
            <div
              *ngFor="let type of filteredTypes"
              class="dropdown-item"
              (mousedown)="selectType(type)"
            >
              {{ type.typeName }}
              <span *ngIf="type.description" class="type-desc">- {{ type.description }}</span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="title">Title *</label>
          <input
            type="text"
            id="title"
            [(ngModel)]="reportForm.title"
            name="title"
            placeholder="Brief title for the report"
            required
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="module">Module</label>
          <input
            type="text"
            id="module"
            [(ngModel)]="reportForm.module"
            name="module"
            placeholder="e.g., Authentication, Dashboard, Reports..."
          />
        </div>
      </div>

      <div class="form-group">
        <label for="symptoms">Symptoms / Description</label>
        <textarea
          id="symptoms"
          [(ngModel)]="reportForm.symptoms"
          name="symptoms"
          rows="4"
          placeholder="Describe the issue, behavior, or content..."
        ></textarea>
      </div>

      <div class="form-group">
        <label for="solution">Solution / Resolution</label>
        <textarea
          id="solution"
          [(ngModel)]="reportForm.solution"
          name="solution"
          rows="4"
          placeholder="Describe the solution or fix..."
        ></textarea>
      </div>

      <div class="form-group">
        <label for="additionalNotes">Additional Notes</label>
        <textarea
          id="additionalNotes"
          [(ngModel)]="reportForm.additionalNotes"
          name="additionalNotes"
          rows="3"
          placeholder="Any additional information..."
        ></textarea>
      </div>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Submitting...' : 'Submit Report' }}
        </button>
        <button type="button" class="btn btn-secondary" (click)="resetForm()">Clear</button>
      </div>
    </form>
  </div>

  <!-- Reports Table -->
  <div class="table-section">
    <h3>Submitted Reports</h3>

    <!-- Filters -->
    <div class="filters">
      <select [(ngModel)]="typeFilter" (change)="applyFilters()">
        <option value="">All Types</option>
        <option *ngFor="let type of reportTypes" [value]="type.typeName">{{ type.typeName }}</option>
      </select>
      <select [(ngModel)]="moduleFilter" (change)="applyFilters()">
        <option value="">All Modules</option>
        <option *ngFor="let module of availableModules" [value]="module">{{ module }}</option>
      </select>
      <button class="btn btn-sm" (click)="clearFilters()">Clear Filters</button>
    </div>

    <div *ngIf="isLoading" class="loading">Loading reports...</div>

    <table *ngIf="!isLoading && reports.length > 0">
      <thead>
        <tr>
          <th>Type</th>
          <th>Title</th>
          <th>Module</th>
          <th>Created</th>
          <th>By</th>
          <th>RAG</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let report of reports">
          <td><span class="badge badge-type">{{ report.typeName }}</span></td>
          <td>{{ report.title }}</td>
          <td>{{ report.module || '-' }}</td>
          <td>{{ report.createdDate | date:'short' }}</td>
          <td>{{ report.createdBy || '-' }}</td>
          <td>
            <span [class]="report.uploadedToRag ? 'badge badge-success' : 'badge badge-warning'">
              {{ report.uploadedToRag ? 'Yes' : 'No' }}
            </span>
          </td>
          <td>
            <button
              *ngIf="!report.uploadedToRag"
              class="btn btn-sm btn-retry"
              (click)="retryUpload(report)"
              [disabled]="retryingReportId === report.reportID"
            >
              {{ retryingReportId === report.reportID ? 'Uploading...' : 'Retry Upload' }}
            </button>
            <span *ngIf="report.uploadedToRag" class="text-muted">-</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!isLoading && reports.length === 0" class="no-data">
      No reports found.
    </div>

    <!-- Pagination -->
    <div *ngIf="totalPages > 1" class="pagination">
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">&laquo; Prev</button>
      <span>Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} total)</span>
      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Next &raquo;</button>
    </div>
  </div>
</div>

